// extracted by mini-css-extract-plugin
export default {"container":"wizard_container__SqkuA","header":"wizard_header__Ddhnw","content":"wizard_content__xE8Zp"};